var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "inner" },
    [
      _c("nav", { staticClass: "breadcrumb is-small has-dot-separator" }, [
        _c("ul", [
          _c(
            "li",
            [_c("b-icon", { attrs: { icon: "home", size: "is-small" } })],
            1
          ),
          _vm.portefeuille
            ? _c("li", { staticClass: "is-active" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.portefeuille.name) +
                      "\n        "
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _c(
        "b-tabs",
        {
          attrs: { animated: false },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "b-tab-item",
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("b-icon", { attrs: { icon: "folder", size: "is-small" } }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("p-home.title-doc")) +
                      "\n      "
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [_c("p", [_vm._v(_vm._s(_vm.$t("p-home.message1")))])]
              )
            ],
            2
          ),
          _c(
            "b-tab-item",
            { attrs: { visible: _vm.allowQuestions && _vm.cgaOk } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("b-icon", {
                    attrs: { icon: "question-circle", size: "is-small" }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("p-home.title-question")) +
                      "\n      "
                  )
                ],
                1
              ),
              this.$route.params.portefeuille
                ? _c("PortefeuilleQuestions", {
                    ref: "question",
                    attrs: { test: true, includePortefeuilleData: true }
                  })
                : _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [_c("p", [_vm._v(_vm._s(_vm.$t("p-home.message2")))])]
                  )
            ],
            2
          ),
          _c(
            "b-tab-item",
            { attrs: { visible: _vm.cgaOk } },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("b-icon", {
                    attrs: { icon: "envelope", size: "is-small", pack: "far" }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("p-home.title-notif")) +
                      "\n      "
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [_c("p", [_vm._v(_vm._s(_vm.$t("p-home.message3")))])]
              )
            ],
            2
          ),
          this.iscgavisible
            ? _c(
                "b-tab-item",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("b-icon", {
                        attrs: {
                          icon: "file-earmark-text-fill",
                          size: "is-small",
                          pack: "far"
                        }
                      }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("p-home.title-cgu")) +
                          "\n      "
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c("CGA", {
                        ref: "cga",
                        attrs: {
                          documentUrl: _vm.pdfUrl,
                          "portefeuille-id": _vm.$route.params.portefeuille
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }